import React, { useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import FormContainer from '../common/FormContainer';
import Title from '../common/Title';
import Subtitle from '../common/Subtitle';
import Buttons from '../common/Buttons';
import InnerForm from './InnerForm';
import { market } from '../../../../../constants';

import {
  createNewAddress,
  editExistingAddress,
} from '../../../../../redux/actions/AddressesActions';

import { makeInitialState } from './intialState';
import { schema } from './validation/schema';

const reducer = (state, { field, value }) => {
  return {
    ...state,
    [field]: value,
  };
};

const Form = ({ ...props }) => {
  const { mobile, handleVisibleClick, address, isBillAddress } = props;
  const reduxDispatch = useDispatch();
  const profile = useSelector((state) => state.profileReducer.profile);
  const regions = useSelector((state) => state.regionsReducer.regions);

  const [state, dispatch] = useReducer(
    reducer,
    makeInitialState(address, profile, regions),
  );

  const [loading, setLoading] = useState(false);
  const [isPrimaryAddress, setIsPrimaryAddress] = useState(
    address ? address.primary === 'true' : false,
  );
  const handleSendClick = async () => {
    let errorInForm = false;
    for (let key in state) {
      if ('error' in schema.validate({ [key]: state[key].value })) {
        errorInForm = true;
        dispatch({
          field: key,
          value: {
            value: state[key].value,
            error: true,
            message: schema.validate({ [key]: state[key].value }).error.message,
            helper: state[key].helper,
            inputAdornment: state[key].inputAdornment,
            label: state[key].label,
          },
        });
      }
    }
    if (!errorInForm) {
      setLoading(true);
      if (address) {
        if (address.isMainCommerce) state.addressName.value = profile.nickName;
        const response = await reduxDispatch(
          editExistingAddress(
            state,
            isPrimaryAddress,
            isBillAddress,
            address.primary,
          ),
        );
        if (response) handleVisibleClick();
      } else {
        const response = await reduxDispatch(
          createNewAddress(state, isPrimaryAddress, isBillAddress),
        );
        if (response) handleVisibleClick();
      }
    }
  };

  const handleCancelClick = () => {
    handleVisibleClick();
  };

  const handleIsPrimary = () => {
    setIsPrimaryAddress(!isPrimaryAddress);
  };

  return (
    <FormContainer>
      <Title
        shouldModify={false}
        title={
          address
            ? `Editar dirección "${address.nickName}"`
            : 'Agregar Nueva Dirección'
        }
      />
      <Subtitle subtitle="*Datos obligatorios" />
      <InnerForm
        state={state}
        dispatch={dispatch}
        modifiable={true}
        address={address}
        profile={profile}
        handleIsPrimary={handleIsPrimary}
        isPrimaryAddress={isPrimaryAddress}
        showThirdLevel={market === 'pe'}
        splitStreetInput={market !== 'pe'}
        isBillAddress={isBillAddress}
      />
      <Buttons
        mobile={mobile}
        loading={loading}
        onSendClick={handleSendClick}
        onCancelClick={handleCancelClick}
      />
    </FormContainer>
  );
};

Form.propTypes = {
  mobile: PropTypes.bool,
  handleVisibleClick: PropTypes.func,
  address: PropTypes.object,
  isBillAddress: PropTypes.bool,
};

export default Form;
